
const staticSeoData = {
    "home":{
        "title":"博商管理科学研究院——更贴近民企的实战管理研究院",
        "keywords":"博商,博商管理,博商学院,博商总裁班,总裁学院,总裁班,总裁班课程,总裁培训,企业培训机构,深圳总裁班,东莞总裁班,广州总裁班",
        "description":"博商管理科学研究院始创于2006年，以民企成长加速器为定位，秉持落地实战，陪伴成长的办学初心，为中国民营企业家提供管理培训、咨询辅导和资源互通等企业全生命周期服务。",
        "remark":"主页",
    },
    "about":{
        "title":"关于博商-博商管理科学研究院",
        "keywords":"博商管理科学研究院,博商背景,博商介绍,博商简介",
        "description":"深圳市博商管理科学研究院股份有限公司（简称：博商），始创于2006年，以“民企成长加速器”为定位，秉承“研究民企、服务民企、传播民企”的办学理念，为中国民营企业家提供管理培训、咨询辅导和资源互通等企业全生命周期服务。",
        "remark":"介绍页",
    },
    "responsibility":{
        "title":"博商公益基金会 | 助学、乡村振兴与公益活动",
        "keywords":"博商公益基金会，慈善组织，助学，乡村振兴，应急救灾，城市发展，敬老安老，绿色环保，公益活动，社会和谐",
        "description":"博商公益基金会成立于2015年，是一家致力于助学、乡村振兴、应急救灾、城市发展、敬老安老及绿色环保等领域的非公募慈善组织。以“博施众济，善道远行”为使命，汇聚社会力量，传递正能量，促进社会和谐。",
        "remark":"社会责任",
    },
    "newsDynamic":{
        "title":"博商管理科学研究院新闻动态",
        "keywords":"博商管理科学研究院，新闻动态，民企成长加速器，管理培训，咨询辅导，资源互通，企业服务，民营企业家成长",
        "description":"关注博商管理科学研究院新闻动态，了解最新的管理培训、咨询辅导和资源互通服务。自2006年始创以来，我们致力于为中国民营企业家提供全生命周期支持，助力企业成长与发展。",
        "remark":"新闻聚合页",
    },
    "industrialReport":{
        "title":"行业报告 | 专注民营企业发展的深度洞察",
        "keywords":"博商管理科学研究院，行业报告，民营企业，企业发展，管理培训，咨询辅导，资源互通，企业服务，深度分析",
        "description":"探索博商管理科学研究院的行业报告，获取关于中国民营企业的最新研究成果和深度分析。我们专注于“研究民企、服务民企、传播民企”，为企业家提供管理培训、咨询辅导及资源互通的全面支持。",
        "remark":"行业报告",
    },
    "boSumPublish":{
        "title":" 博商出版 | 专注民营企业成长的精选书籍",
        "keywords":"博商出版，新博商精神，博商理想国，复盘经营计划，民营企业，企业管理，实战经验，企业成长，管理培训",
        "description":"探索博商管理科学研究院的出版栏目，阅读《新博商精神》《博商理想国Ⅰ/Ⅱ》《复盘经营计划：挖掘影响业绩的深层原因》等书籍。这些作品为中国民营企业家提供深刻的管理见解和实战经验，助力企业全生命周期发展。",
        "remark":"博商出版",
    },
    "teaching":{
        "title":"博商教学中心 | 全球企业家与商界精英的学习平台",
        "keywords":"博商教学中心，全球拓展，企业家培训，商界精英，管理培训，分教中心，北京，上海，广州，东京，新加坡，吉隆坡，雅加达，胡志明市",
        "description":"博商管理科学研究院教学中心网络覆盖国内外，设有北京、上海、广州等12个重点城市及东京、新加坡、吉隆坡、雅加达、胡志明市等国际分教中心。我们致力于为全球企业家和商界精英提供高效优质的管理培训与学习体验，助力民企成长。",
        "remark":"教学中心",
    },
    "course":{
        "title":"博商课程服务 | 企业管理实战教育与指导",
        "keywords":"博商课程服务，企业管理，实战教育，中小企业，企业家培训，管理知识，专业导师，落地课程，经营指导",
        "description":"博商管理科学研究院凭借18年实战教育经验，专注为中小企业及企业家提供科学前沿的管理知识。由100+位经验丰富的专业导师授课，提供真实有效的落地课程和指导，帮助企业家解决实际管理问题，实现高效经营。",
        "remark":"课程服务",
    },
    "personalLearning":{
        "title":"博商个人学习系统班 | 企业管理与领导力提升课程",
        "keywords":"博商个人学习系统班，企业管理，领导力提升，总裁项目，英才项目，资本项目，战略提升，实战模型，解决方案",
        "description":"博商个人学习系统班提供长期系统课程，专为企业领导者和管理者设计，包括总裁项目、英才项目、资本项目三大经典类型。课程专注于提升企业战略和领导力，配套实战模型工具及解决方案，助力企业长久稳定发展。",
        "remark":"个人学习系统班",
    },
    "teamLearning":{
        "title":"博商团队共学研习社 | 提升团队核心竞争力的短期集训",
        "keywords":"博商团队共学研习社，短期集训，团队培训，垂直领域能力，市场突破，效率提升，资源优化，模式创新，核心竞争力",
        "description":"博商团队共学研习社提供短期集训课程，专为需要提升垂直领域能力的团队设计。课程专注于市场、效率、资源、模式的突破，通过团队共同学习，强化实操能力，提升团队核心竞争力，促进企业整体发展。",
        "remark":"团队共学研习社",
    },
    "accompanyRunners":{
        "title":"博商陪跑系列 | 长期陪伴企业执行与增长项目",
        "keywords":"博商陪跑系列，长期陪伴，项目执行，团队指导，战略规划，组织管理，财务指导，人力资源，定制化内训，增长瓶颈",
        "description":"博商陪跑系列提供长期陪伴学员落地执行的项目，适合执行条件欠缺、需要教练陪伴的团队。涵盖战略、组织、财务、人力等方面的指导和定制化内训，理论结合实践，帮助企业突破增长瓶颈，少走弯路，实现有效结果。",
        "remark":"陪跑系列",
    },
    "lead":{
        "title":"博商领跑系列 | 深度咨询助力企业成为行业领跑者",
        "keywords":"博商领跑系列，企业经营管理，深度咨询，自媒体咨询，运营效率，组织能力，销售管理，财务合规，内容定位，爆款视频，团队搭建，行业领跑者",
        "description":"博商领跑系列提供企业经营管理与自媒体领域的深度咨询服务。适合规模企业和新媒体领域的决策者，通过运营效率、组织能力、销售管理、财务合规及内容定位、爆款视频模板、团队搭建等，帮助企业实现全面突破，建立行业竞争优势。",
        "remark":"领跑系列",
    },
    "onLine":{
        "title":"博商线上系列 | 小麦课堂随时随地提升管理技能",
        "keywords":"博商线上系列，小麦课堂，在线学习，企业管理，商业模式，股权设计，财税管理，盈利增长，销售管理，管理方法论，碎片化学习",
        "description":"博商小麦线上学习课堂为企业家和管理者提供180+精品课程视频，涵盖商业模式、股权设计、财税管理、盈利增长、销售管理等10大管理方法论。适合时间碎片化的学习需求，帮助学员提升管理认知，掌握实战方法，实现有效落地。",
        "remark":"线上系列",
    },
    "combat":{
        "title":"博商实战导师 | 顶尖专家助力企业成长",
        "keywords":"博商实战导师，知名专家，咨询师，实战经验，企业辅导，商业名师，企业增长，粉丝导流，变现转化，行业佼佼者",
        "description":"博商实战导师团队由国内知名专家和咨询师组成，拥有15年以上实战经验，每位导师平均辅导超过50家企业。我们已打造100+商业类头部名师IP，赋能30万+企业家实现增长，拥有2亿+粉丝，实现导流变现，成为行业领军者。",
        "remark":"实战导师",
    },
    "fieldIInstructor":{
        "title":"博商实战导师 | 国内外知名专家助力企业成长",
        "keywords":"博商实战导师，知名专家，咨询师，实战经验，企业辅导，商业名师，企业增长，粉丝导流，行业领军者",
        "description":"博商实战导师团队由国内外知名专家和咨询师组成，拥有平均15年以上的实战经验和学术研究背景，每位导师辅导超过50家企业。我们已打造100多位商业类头部名师IP，赋能30万+企业家实现增长，总粉丝数超过2亿，成为行业佼佼者。",
        "remark":"博商实战导师",
    },
    "student":{
        "title":"博商企业学员 | 多行业企业家校友网络",
        "keywords":"博商企业学员，企业家校友，行业覆盖，IT互联网，跨境电商，新能源，环保，家居，母婴，金融，教育，房地产，企业培训",
        "description":"博商管理科学研究院拥有超过10万名企业家校友，学员企业覆盖200+细分行业，包括IT互联网、跨境电商、新能源、环保、家居、母婴、金融、教育、房地产等。我们致力于为各行业企业家提供优质的管理培训与成长平台。",
        "remark":"企业学员",
    },
    "outstandingAlumni":{
        "title":"博商优秀校友 | 引领多行业发展的企业家群体",
        "keywords":"博商优秀校友，企业家网络，多行业覆盖，IT互联网，跨境电商，新能源，环保，家居，金融，教育，医疗，行业引领者",
        "description":"博商管理科学研究院拥有超过10万名优秀企业家校友，遍布200+细分行业，包括IT互联网、跨境电商、新能源、环保、家居、金融、教育、医疗等。我们的校友在各自领域中发挥着引领作用，推动行业进步与创新。",
        "remark":"优秀校友",
    },
    "recruit":{
        "title":"加入博商 | 职业发展与招聘机会",
        "keywords":"加入博商，校园招聘，社会招聘，师资招聘，职业发展，管理咨询，教育行业，人才招聘",
        "description":"加入博商管理科学研究院，探索丰富的职业发展机会。我们提供校园招聘、社会招聘和师资招聘，欢迎有志于教育和管理咨询行业的优秀人才加入，共同推动企业管理教育的创新与发展。",
        "remark":"加入博商",
    },
    "WCampusIntroduce":{
        "title":"博商校园招聘 | 开启职业生涯的新篇章",
        "keywords":"博商校园招聘，毕业生机会，职业发展，管理培训，教育行业，职业生涯，人才招聘",
        "description":"加入博商管理科学研究院校园招聘计划，迈出职业生涯的第一步。我们为优秀毕业生提供多样化的职业发展机会，涵盖教育培训、管理咨询及相关领域，助力您在专业环境中成长与发展。",
        "remark":"校园招聘",
    },
    "WSocialIntroduce":{
        "title":"博商社会招聘 | 发展您的职业新高度",
        "keywords":"博商社会招聘，职业机会，管理咨询，教育行业，专业发展，人才招聘，职业生涯",
        "description":"博商管理科学研究院诚邀各界专业人才加入我们的团队，通过社会招聘计划，探索教育与管理咨询领域的职业发展机会。我们提供多样化的岗位，助力您的职业生涯迈向新高度。",
        "remark":"社会招聘",
    },
    "WTeacherRecruitment":{
        "title":"博商师资招聘 | 加入顶尖教育团队",
        "keywords":"博商师资招聘，教育专家，管理咨询，教学岗位，教育创新，人才招聘，教育团队",
        "description":"博商管理科学研究院诚邀优秀教育和管理咨询领域的专家加入我们的师资团队。通过师资招聘计划，您将有机会与顶尖教育者合作，推动企业管理教育的创新与发展。",
        "remark":"师资招聘",
    },
}
const initSeo = {};
//数据来自静态设置
initSeo.seoConFromStatic = (val) => {
    let data = staticSeoData[val];
    document.querySelector('meta[name="description"]').setAttribute("content", data.description);
    document.querySelector('meta[name="keywords"]').setAttribute("content", data.keywords);
    document.title = data.title;
};

//数据来自动态设置
initSeo.seoConFromDynamic = (val) => {
    document.querySelector('meta[name="description"]').setAttribute("content", val.description);
    document.querySelector('meta[name="keywords"]').setAttribute("content", val.keywords);
};

//只设置标题
initSeo.seoTitleOnly = (title) => {
    document.title = title;
}
export default initSeo;



// WEBPACK FOOTER //
// ./src/api/seoApi.js